/* src/app/shared/modals/modal-new-request/modal-new-request.component.scss */
.access-token-url {
  min-height: 9em;
}
.form-control[readonly] {
  background-color: #e9ecef;
  color: #000;
  opacity: 1;
  pointer-events: all;
}
.btn-info,
.btn-info:hover,
.btn-info:active,
.btn-info:disabled {
  background-color: #4097ff;
  border-color: #4097ff;
  color: white;
}
.btn-check:active + .btn-info,
.btn-check:checked + .btn-info,
.btn-info.active,
.btn-info:active,
.show > .btn-info.dropdown-toggle {
  background-color: #51a8ff;
  background-color: #51a8ff;
}
#internalReference {
  height: 34px;
}
/*# sourceMappingURL=modal-new-request.component.css.map */
